import { render, staticRenderFns } from "./SliderRtl.vue?vue&type=template&id=a33d2cc8&"
import script from "./SliderRtl.vue?vue&type=script&lang=js&"
export * from "./SliderRtl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports